module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "仓库列表",
      "disabled": !_vm.filters.IsAdmin
    },
    on: {
      "change": _vm.getWA
    },
    model: {
      value: (_vm.filters.WID),
      callback: function($$v) {
        _vm.$set(_vm.filters, "WID", $$v)
      },
      expression: "filters.WID"
    }
  }, _vm._l((_vm.warehouses), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": item.Code + item.Name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getWA
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.waList,
      "highlight-current-row": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "DataID",
      "width": "100",
      "label": "编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "编码",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.Warehouse.Code) + " " + _vm._s(scope.row.Code))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Types",
      "width": "100",
      "label": "类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Name",
      "width": "180",
      "label": "库区名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "min-width": "100",
      "prop": "Status"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Date",
      "label": "时间",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("设置")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "编码",
      "placeholder": "此编码在仓库启用后，不能修改，只能使用一个"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "仓库列表"
    },
    model: {
      value: (_vm.editForm.WID),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "WID", $$v)
      },
      expression: "editForm.WID"
    }
  }, _vm._l((_vm.warehouses), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": item.Code + item.Name
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "disabled": true
    },
    model: {
      value: (_vm.editForm.Code),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Code", $$v)
      },
      expression: "editForm.Code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "库区类型"
    },
    model: {
      value: (_vm.editForm.Types),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Types", $$v)
      },
      expression: "editForm.Types"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "操作区",
      "value": "操作区"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "存储区",
      "value": "存储区"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "待检区",
      "value": "待检区"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "集货区",
      "value": "集货区"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "活动区",
      "value": "活动区"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "残次区",
      "value": "残次区"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "名称"
    },
    model: {
      value: (_vm.editForm.Name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Name", $$v)
      },
      expression: "editForm.Name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态设置"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.changeStatus),
      callback: function($$v) {
        _vm.changeStatus = $$v
      },
      expression: "changeStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "正常",
      "value": "正常"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "停用",
      "value": "停用"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.setStatus(_vm.editForm.DataID)
      }
    }
  }, [_vm._v("变更状态")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "100px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "编码",
      "placeholder": "此编码在仓库启用后，不能修改，只能使用一个"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "仓库列表"
    },
    model: {
      value: (_vm.addForm.WID),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "WID", $$v)
      },
      expression: "addForm.WID"
    }
  }, _vm._l((_vm.warehouses), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": item.Code + item.Name
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "库区类型"
    },
    model: {
      value: (_vm.addForm.Types),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Types", $$v)
      },
      expression: "addForm.Types"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "操作区",
      "value": "操作区"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "存储区",
      "value": "存储区"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "待检区",
      "value": "待检区"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "集货区",
      "value": "集货区"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "活动区",
      "value": "活动区"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "残次区",
      "value": "残次区"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "名称"
    },
    model: {
      value: (_vm.addForm.Name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Name", $$v)
      },
      expression: "addForm.Name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态设置"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.addForm.Status),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Status", $$v)
      },
      expression: "addForm.Status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "正常",
      "value": "正常"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "停用",
      "value": "停用"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee2c7e04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/warehouseConfig/WAList.vue
// module id = 851
// module chunks = 1